export enum ProuniDocumentType {
  inscriptionForm = 'inscriptionForm',
  identity = 'identity',
  cpf = 'cpf',
  ctps = 'ctps',
  guardian = 'guardian',
  residenceProof = 'residenceProof',
  familyMemberId = 'familyMemberId',
  familyMemberResidenceProof = 'familyMemberResidenceProof',
  familyMemberActivityProof = 'familyMemberActivityProof',
  ownActivityProof = 'ownActivityProof',
  ownIncomeProofMonth1 = 'ownIncomeProofMonth1',
  ownIncomeProofMonth2 = 'ownIncomeProofMonth2',
  ownIncomeProofMonth3 = 'ownIncomeProofMonth3',
  familyMemberIncomeProofMonth1 = 'familyMemberIncomeProofMonth1',
  familyMemberIncomeProofMonth2 = 'familyMemberIncomeProofMonth2',
  familyMemberIncomeProofMonth3 = 'familyMemberIncomeProofMonth3',
  alimonyProof = 'alimonyProof',
  highSchoolCertificate = 'highSchoolCertificate',
  highSchoolTranscript = 'highSchoolTranscript',
  teacherProof = 'teacherProof',
  disabilityReport = 'disabilityReport',
  other = 'other',
}

export enum ProuniApplicationStatus {
  draft = 'draft',
  submitted = 'submitted',
  awaiting = 'awaiting',
  approved = 'approved',
  rejected = 'rejected',
}

export enum ProuniDocumentStatus {
  pending = 'pending',
  accepted = 'accepted',
  rejected = 'rejected',
}

export enum PersonalDocumentKind {
  identity = 'identity',
  ctps = 'ctps',
}

export enum InstitutionType {
  public = 'public',
  private = 'private',
}

export interface ProuniEligibility {
  isEligible: boolean;
  course?: string | null;
}

export interface ProuniDocument {
  id?: number;
  documentType: ProuniDocumentType | string;
  fileName?: string;
  mimeType?: string;
  status?: ProuniDocumentStatus | string;
  rejectionReason?: string | null;
  familyMemberId?: number | null;
  description?: string | null;
  url?: string | null;
}

export interface ProuniFamilyMember {
  id?: number;
  name?: string;
  income?: number | string;
}

export interface ProuniApplication {
  id?: number;
  status?: ProuniApplicationStatus | string;
  ra?: string | null;
  rejectionReason?: string | null;
  fullName?: string;
  cpf?: string;
  email?: string;
  phone?: string;
  birthDate?: string;
  gender?: string;
  sisProuniInscriptionNumber?: string;
  docType?: PersonalDocumentKind | string;
  rgNumber?: string;
  issueDate?: string;
  issuingBody?: string;
  uf?: string;
  isOfAge?: boolean;
  addressZipCode?: string;
  addressStreet?: string;
  addressNumber?: string;
  addressComplement?: string;
  addressNeighborhood?: string;
  addressCity?: string;
  addressState?: string;
  residenceProofType?: string;
  income?: number | string;
  activityType?: string;
  hasAlimony?: boolean;
  institutionType?: InstitutionType | string;
  isPublicSchoolTeacher?: boolean;
  hasDisability?: boolean;
  contactMethod?: string;
  acceptedTerms?: boolean;
  pipelineState?: Record<string, any> | null;
  familyMembers?: ProuniFamilyMember[];
  documents?: ProuniDocument[];
}

export interface UploadDocumentPayload {
  file: File;
  documentType: ProuniDocumentType | string;
  familyMemberId?: number | null;
  description?: string | null;
}
